//@ts-nocheck
/**
 * Makes sure the options have all the properties that they need to after being pulled from the cloud.
 */
function enforceOptions(existing) {
	const newDateString = new Date().toISOString();
	const enforced = {
		id: existing.id,
		fieldTemplateId: existing.fieldTemplateId,
		formTemplate: existing.formTemplate,
		label: existing.label || "",
		value: existing.value || "",
		docId: existing.docId || "",
		group: existing.group,
		readGroups: [...existing.readGroups],
		exportData: existing.exportData || [],
		exportActions: existing.exportActions || [],
		linkedId: existing.linkedId || "",
		deleted: existing.deleted || false,
		createdAt: existing.createdAt || newDateString,
		updatedAt: existing.updatedAt || newDateString,
	};

	return enforced;
}

export default enforceOptions;
